import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  addressBookTitle: (
    <FormattedMessage
      id="CompleteSms.AddressBookTitle"
      defaultMessage="Address Book"
    ></FormattedMessage>
  ),
  backText: (
    <FormattedMessage
      id="Global.BackText"
      defaultMessage="Back"
    ></FormattedMessage>
  ),
  cancelText: (
    <FormattedMessage
      id="CompleteSms.CancelText"
      defaultMessage="Cancel"
    ></FormattedMessage>
  ),
  emailText: (
    <FormattedMessage
      id="CompleteSms.EmailText"
      defaultMessage="Email Address"
    ></FormattedMessage>
  ),
  entryNameText: (
    <FormattedMessage
      id="CompleteSms.EntryNameTextMandatory"
      defaultMessage="Entry Name *"
    ></FormattedMessage>
  ),
  firstNameText: (
    <FormattedMessage
      id="CompleteSms.FirstNameText"
      defaultMessage="First Name"
    ></FormattedMessage>
  ),
  lastNameText: (
    <FormattedMessage
      id="CompleteSms.LastNameText"
      defaultMessage="Last Name"
    ></FormattedMessage>
  ),
  loadingText: (
    <FormattedMessage
      id="App.LoadingText"
      defaultMessage="Loading..."
    ></FormattedMessage>
  ),
  manageAddressButton: (
    <FormattedMessage
      id="CompleteSms.ManageAddressButton"
      defaultMessage="Manage Address Books"
    ></FormattedMessage>
  ),
  manageDistListButton: (
    <FormattedMessage
      id="CompleteSms.ManageDistListButton"
      defaultMessage="Manage Distribution Lists"
    ></FormattedMessage>
  ),
  middleNameText: (
    <FormattedMessage
      id="CompleteSms.MiddleNameText"
      defaultMessage="Middle Name"
    ></FormattedMessage>
  ),
  phoneText: (
    <FormattedMessage
      id="CompleteSms.MobileTextMandatory"
      defaultMessage="Phone Number"
    ></FormattedMessage>
  ),
  searchContacts: (
    <FormattedMessage
      id="CompleteSms.SearchContacts"
      defaultMessage="Search Contacts"
    ></FormattedMessage>
  ),
  importText: (
    <FormattedMessage
      id="CompleteSms.ImportContactsText"
      defaultMessage="Import Contacts"
    ></FormattedMessage>
  ),
  deleteContactText: (
    <FormattedMessage
      id="CompleteSms.DeleteContactText"
      defaultMessage="Delete Contact"
    ></FormattedMessage>
  ),
  exportText: (
    <FormattedMessage
      id="CompleteSms.ExportContactsText"
      defaultMessage="Export Contacts"
    ></FormattedMessage>
  ),
  statistics: (
    <FormattedMessage
      id="CompleteSms.StatText"
      defaultMessage="Statistics"
    ></FormattedMessage>
  ),
  save: (
    <FormattedMessage
      id="CompleteSms.Save"
      defaultMessage="Save"
    ></FormattedMessage>
  ),
  saving: (
    <FormattedMessage
      id="CompleteSms.Saving"
      defaultMessage="Saving"
    ></FormattedMessage>
  ),
  global: (
    <FormattedMessage
      id="CompleteSms.Global"
      defaultMessage="Global"
    ></FormattedMessage>
  ),
  personal: (
    <FormattedMessage
      id="CompleteSms.Personal"
      defaultMessage="Personal"
    ></FormattedMessage>
  ),
  deleteText: (
    <FormattedMessage
      id="CompleteSms.DeleteText"
      defaultMessage="Delete"
    ></FormattedMessage>
  ),
  globalListText: (
    <FormattedMessage
      id="CompleteSms.GlobalListText"
      defaultMessage="Global List"
    ></FormattedMessage>
  ),
  personalListText: (
    <FormattedMessage
      id="CompleteSms.PersonalListText"
      defaultMessage="Personal List"
    ></FormattedMessage>
  ),
  globalBlacklistText: (
    <FormattedMessage
      id="CompleteSms.GlobalBlacklistText"
      defaultMessage="Global Blacklist"
    ></FormattedMessage>
  ),
  totalContactText: (
    <FormattedMessage
      id="CompleteSms.TotalContactText"
      defaultMessage="Total Contacts"
    ></FormattedMessage>
  ),
  deleteGlobalContactsHeader: (
    <FormattedMessage
      id="CompleteSmsDelete.AllContactsHeader"
      defaultMessage="Delete Global Contacts"
    ></FormattedMessage>
  ),
  deletePersonalContactsHeader: (
    <FormattedMessage
      id="CompleteSmsDelete.PersonalContactsHeader"
      defaultMessage="Delete Personal Contacts"
    ></FormattedMessage>
  ),
  deleteGlobalContactsBody: (
    <FormattedMessage
      id="CompleteSmsDelete.GlobalContactsBody"
      defaultMessage="You are about to permanently delete all Global Contacts, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  deletePersonalContactsBody: (
    <FormattedMessage
      id="CompleteSmsDelete.PersonalContactsBody"
      defaultMessage="You are about to permanently delete all Personal Contacts, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  deleteListsBody: (
    <FormattedMessage
      id="CompleteSmsDelete.deleteListsBody"
      defaultMessage="You are about to permanently delete these Lists, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  deleteListContactsBody: (
    <FormattedMessage
      id="CompleteSmsDelete.deleteListContactsBody"
      defaultMessage="You are about to delete these Contacts from this List, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  deleteContactsBody: (
    <FormattedMessage
      id="CompleteSmsDelete.ContactsBody"
      defaultMessage="You are about to permanently delete these Contacts, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  noData: (
    <FormattedMessage
      id="Error.NoData"
      defaultMessage="Cannot access data"
    ></FormattedMessage>
  ),
  deleteBlackListItems: (
    <FormattedMessage
      id="CompleteSmsDelete.BlackListItems"
      defaultMessage="You are about to permanently delete this Blacklist item, are you sure you want to do this?"
    ></FormattedMessage>
  ),
  exportContacts: (
    <FormattedMessage
      id="Websms.ExportContacts"
      defaultMessage="Export Contacts"
    />
  ),
  exportDistList: (
    <FormattedMessage
      id="Websms.exportDistList"
      defaultMessage="Export Lists"
    />
  ),
  searchContact: (
    <FormattedMessage
      id="Websms.SearchContact"
      defaultMessage="Search Contacts By Name or Number"
    />
  ),
  importContacts: (
    <FormattedMessage id="Websms.ImportContacts" defaultMessage="Import" />
  ),
  createNewButton: (
    <FormattedMessage id="Websms.CreateNewButton" defaultMessage="Add New" />
  ),
  select: <FormattedMessage id="Websms.Select" defaultMessage="Select" />,
  nameText: <FormattedMessage id="Websms.NameText" defaultMessage="Name" />,

  mobileText: (
    <FormattedMessage id="Websms.MobileText" defaultMessage="Mobile Number" />
  ),
  type: <FormattedMessage id="Websms.Type" defaultMessage="Type" />,
  lists: <FormattedMessage id="Websms.Lists" defaultMessage="Lists" />,
  searchByName: (
    <FormattedMessage
      id="Websms.searchByName"
      defaultMessage="Search By List Name"
    />
  ),
  searchByNumber: (
    <FormattedMessage
      id="Websms.searchByNumber"
      defaultMessage="Search By Number"
    />
  ),
  listName: (
    <FormattedMessage id="Websms.ListName" defaultMessage="List Name" />
  ),
  displayName: (
    <FormattedMessage id="Websms.DisplayName" defaultMessage="Name" />
  ),
  contactType: (
    <FormattedMessage id="Websms.ContactType" defaultMessage="Contact Type" />
  ),
  quantityOfContacts: (
    <FormattedMessage
      id="Websms.QuantityofContacts"
      defaultMessage="Quantity of Contacts"
    />
  ),
  updateList: (
    <FormattedMessage id="Websms.UpdateList" defaultMessage="Update List" />
  ),
  createList: (
    <FormattedMessage id="Websms.CreateList" defaultMessage="Create List" />
  ),
  deleteSelected: (
    <FormattedMessage
      id="Websms.DeleteSelected"
      defaultMessage="Delete Selected"
    />
  ),
};

export default FormattedMessages;
